import React, { useEffect, useState } from 'react';
import { ModuleTitle } from './utilities/ModuleTitle.tsx';
import { BasicFetch } from '../utils/BasicFetch.ts';
import { UserInfo } from '../types/UserInfo';
import { ReptoolModal } from './utilities/ReptoolModal.tsx';
import { SubscriptionModal } from './stripe/SubscriptionModal.tsx';
import { CancelSubscriptionModal } from './stripe/CancelSubscriptionModal.tsx';
import { ModifySubscriptionModal } from './stripe/ModifySubscriptionModal.tsx';
import { useRepToolContext } from '../RepToolContext.tsx';

export const ProfileInfo = ({
  info,
  backToMenu,
  backToLogin,
  getUserInfo
}: {
  info: UserInfo,
  backToMenu: () => void,
  backToLogin: () => void,
  getUserInfo: () => void
}) => {
  const [showInfo, setShowInfo] = useState(true);
  const [successMessage, setSuccessMessage] = useState('');
  const [showUpdateProfile, setShowUpdateProfile] = useState(false);
  const [showUpdatePassword, setShowUpdatePassword] = useState(false);
  const [currentInfo, setCurrentInfo] = useState(info);
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [passwordInvalid, setPasswordInvalid] = useState(false);
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const [showViewSubscriptionModal, setShowViewSubscriptionModal] = useState(false);
  const { appendControls } = useRepToolContext();
  const [openConfirmationModal, setOpenConfirmationModal] = useState<boolean>(false);

  useEffect(() => {
    if (!showViewSubscriptionModal && !showSubscriptionModal) {
      appendControls(null, "Profile Info");
    }
  }, [showViewSubscriptionModal, showSubscriptionModal]);

  useEffect(() => {
    if (!info) {
      getUserInfo();
    } else {
      setCurrentInfo(info);
    }
  }, [info, getUserInfo]);

  const turnAllOff = () => {
    setShowInfo(false);
    setShowUpdateProfile(false);
    setShowUpdatePassword(false);
  }
  const updateProfile = () => {

    let formData = new FormData();
    Object.keys(currentInfo).forEach(attr => {
      formData.append(attr, currentInfo[attr]);
    })
    // this is unused on server side
    formData.append("password", '');
    BasicFetch(
      {
        url: `${(window as any).serverLocation}user/update_account`,
        data: formData,
        method: 'POST',
        contentType: 'multipart/form-data',
        onSuccess: (data) => {
          localStorage.setItem("reptoolCookie", data.token);
          setShowUpdateProfile(false);
          alert("Profile sucessfully updated")
          getUserInfo();
          setShowInfo(true);
        },
        onFail: () => {
          alert("Failed to update profile")
        }
      })
  }
  const updatePassword = () => {
    if (password !== password2 || password.length < 8) {
      setPasswordInvalid(true);
      return;
    }
    let formData = new FormData();
    formData.append("password", password);
    formData.append("password2", password2);
    BasicFetch(
      {
        url: `${(window as any).serverLocation}user/update_password`,
        data: formData,
        method: 'POST',
        contentType: 'multipart/form-data',
        onSuccess: (data) => {
          localStorage.setItem("reptoolCookie", data.token);
          alert("Password sucessfully updated")

          setShowUpdatePassword(false);
          setShowInfo(true);
        },
        onFail: () => {
          alert("Failed to update password. Please try again later.");
        },
      })
  }
  const deleteAccount = () => {
    BasicFetch(
      {
        url: `${(window as any).serverLocation}user/delete_account`,
        method: 'DELETE',
        onSuccess: (data) => {
          alert("Account deleted successfully");
          backToLogin();
          localStorage.setItem("reptoolCookie", '')
        },
        onFail: () => {
          alert("Failed to delete account. Please try again later.")
        },
      })
  }
  const logout = () => {
    BasicFetch(
      {
        url: `${(window as any).serverLocation}logout`,
        method: 'POST',
        contentType: 'multipart/form-data',
        onSuccess: (data) => {
          backToLogin();
          localStorage.setItem("reptoolCookie", '')
        },
        onFail: () => {
          alert("Failed to logout. Please try again later.")
        },
      })

  }
  return (
    <React.Fragment>
      <ModuleTitle title="Profile Info" backToMenu={() => backToMenu()} />
      {showSubscriptionModal && <SubscriptionModal closeModal={() => setShowSubscriptionModal(false)} userInfo={info} />}
      {showViewSubscriptionModal && <ModifySubscriptionModal closeModal={() => setShowViewSubscriptionModal(false)} userInfo={info} />}

      {openConfirmationModal && <ReptoolModal
        title="Delete Account"
        body={<React.Fragment>
          <p>Are you sure you want to delete your account? This action cannot be undone.</p>
          <div className='mt-3 d-flex flex-row justify-content-around'>
            <div onClick={() => setOpenConfirmationModal(false)} className="home-button btn button">Cancel</div>
            <div onClick={() => deleteAccount()} className="home-button btn button">Delete Account</div>
          </div>
        </React.Fragment>}
        closeModal={() => setOpenConfirmationModal(false)} />
      }
      <div className='app text-center mt-0'>
        {successMessage && <h6 id="form-alert" className="alert alert-success">{successMessage}</h6>}

        {showInfo && <React.Fragment>
          <div id="profile-info">
            <div className="mt-3">
              <h5>Name:</h5>
              <h6 id="user-name">{currentInfo.first_name} {currentInfo.last_name}</h6>
            </div>
            <div className="mt-3">
              <h5>Breeder Name:</h5>
              <h6 id="breeder-name">{currentInfo.breeder_name}</h6>
            </div>
            <div className="mt-3">
              <h5>Subscription:</h5>
              <div className=''>
                <h6 className='mb-0'>{currentInfo.subscription?.subscription_label || "Free Membership"}</h6>
                {(currentInfo.subscription?.end_date || currentInfo.subscription?.next_payment_date) && <div>
                  {currentInfo.subscription?.end_date ? <small className='ml-2 text-light'>
                    Expires on: {new Date(currentInfo.subscription.end_date).toDateString()}
                  </small> : <small className='ml-2 text-light'>
                    {currentInfo.subscription.next_payment_date && <>Next Payment: {new Date(currentInfo.subscription.next_payment_date).toDateString()}</>}
                  </small>}
                </div>}
              </div>
            </div>

            <div className="mt-3">
              <h5>Account Created on:</h5>
              <h6 id="member-since">{new Date(currentInfo.creation_date).toDateString()}</h6>
            </div>
            <div className="mt-3">
              <h5>Scales: <i className=" ml-2 fa d-none fa-question text-blue" data-toggle="popover" title="Popover title" data-content="Scales are a point system, that shows how much you have contributed to the RepTool community. Earn Scales by suggesting morphs or genes or uploading photos."></i></h5>
              <h6 id="scale-points">{currentInfo.scales}</h6>
            </div>
          </div>
          <div id="profile-option-buttons" className='mt-5 d-flex flex-column'>
            {currentInfo.active_paid_subscriptions?.length === 0 ?
              <div id="subscription-btn" onClick={() => setShowSubscriptionModal(true)} className="home-button btn button mx-auto">Purchase Subscription</div>
              : <div id="view-subscription-btn" onClick={() => setShowViewSubscriptionModal(true)} className="home-button btn button mx-auto">View Subscription</div>}
            <div id="reset-pass-btn" onClick={() => { turnAllOff(); setShowUpdatePassword(true) }} className="home-button btn button mx-auto mt-3">Update Password</div>
            <div id="profile-update" onClick={() => { turnAllOff(); setShowUpdateProfile(true) }} className="home-button btn mt-3 button mx-auto">Edit Info</div>
            <div id="logout-btn" onClick={() => logout()} className="home-button btn mt-3 button mx-auto">Logout</div>
            <div id='delete-act-btn' onClick={() => setOpenConfirmationModal(true)} className="mt-5 btn btn-outline-danger mx-auto">Delete Account</div>
          </div>
        </React.Fragment>
        }
        {showUpdatePassword && <form id="update-password-form" className="px-3" method="post">
          <div className="text-center mt-3" >
            <h6>Password:</h6>
            <input id="password" type="password" value={password} onChange={(event) => { setPasswordInvalid(false); setPassword(event.target.value); }} className="form-control glow home-input" required />
          </div>
          <div id="password2-container" className="text-center register-field mt-3">
            <h6>Confirm Password:</h6>
            <input id="password2" type="password" value={password2} onChange={(event) => { setPasswordInvalid(false); setPassword2(event.target.value); }} className={`form-control glow home-input ${passwordInvalid ? 'is-invalid' : ''}`} required />
            <div className='invalid-feedback'>Passwords must match and be atleast 8 characters long</div>
          </div>
          <div className="home-button-container mt-4 d-flex flex-column align-items-center">
            <div id="update-pass-btn" onClick={() => updatePassword()} className="home-button btn button">Update Password</div>
            <div id="pass-cancel-btn" onClick={() => { turnAllOff(); setShowInfo(true) }} className="home-button btn mt-3 button">Cancel</div>
          </div>
        </form>
        }
        {showUpdateProfile && <form id="update-profile-form" className="px-3">
          <div className="">
            <h6>Email:</h6>
            <input
              id="email-data"
              type="email"
              value={currentInfo.email}
              onChange={(event) => setCurrentInfo({ ...currentInfo, email: event.target.value })}
              className="form-control glow home-input"
              required
              readOnly
            />
          </div>
          <div className="register-field mt-3">
            <h6>First Name:</h6>
            <input id="first-name-data" type="text" value={currentInfo.first_name} onChange={(event) => setCurrentInfo({ ...currentInfo, first_name: event.target.value })} className="form-control glow home-input" required />
          </div>
          <div className="register-field mt-3">
            <h6>Last Name:</h6>
            <input id="last-name-data" type="text" value={currentInfo.last_name} onChange={(event) => setCurrentInfo({ ...currentInfo, last_name: event.target.value })} className="form-control glow home-input" required />
          </div>
          <div className="register-field mt-3">
            <div className="d-flex flex-row justify-content-center">
              <h6>Breeder Name: </h6><small className="text-light pt-1 mb-2 ml-2">(optional)</small>
            </div>
            <input id="breeder-name-data" type="text" value={currentInfo.breeder_name} onChange={(event) => setCurrentInfo({ ...currentInfo, breeder_name: event.target.value })} className="form-control glow home-input" />
          </div>
          <div className="register-field mt-3">
            <div className="d-flex flex-row justify-content-center">
              <h6>Photo Credit:</h6><small className="text-light pt-1 mb-2 ml-2">(optional)</small>
            </div>
            <input id="breeder-credit-data" type="text" value={currentInfo.breeder_credit} onChange={(event) => setCurrentInfo({ ...currentInfo, breeder_credit: event.target.value })} className="form-control glow home-input" />
          </div>
          <div className="home-button-container mt-4 d-flex flex-column align-items-center">
            <div id="update-profile-btn" onClick={() => updateProfile()} className="home-button btn button" >Update Info</div>
            <div id="profile-cancel-btn" onClick={() => { turnAllOff(); setShowInfo(true) }} className="home-button mt-3 btn button">Cancel</div>
          </div>
        </form>}
      </div>
    </React.Fragment>
  )
}